export default () => {
    let deferredObj = {};
    const promise = new Promise(function(resolve, reject) {
        deferredObj = {
            resolve,
            reject
        }
    });
    deferredObj.promise = promise;
    return deferredObj;
}